import React from 'react';

import styles from './GroupFooter.module.css';

export default () => <div className={styles.container} />;
